import { render } from "./ModalDocumentUploadComplete.vue?vue&type=template&id=02574634&scoped=true"
import script from "./ModalDocumentUploadComplete.vue?vue&type=script&lang=js"
export * from "./ModalDocumentUploadComplete.vue?vue&type=script&lang=js"

import "./ModalDocumentUploadComplete.vue?vue&type=style&index=0&id=02574634&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02574634"]])

export default __exports__